import React from "react"
import { bind } from '@src/utils'
import { pick } from '@src/lib/lodash'
import Main from '@src/components/main'
import Table from '@src/components/table'
import { titleMap, headerMap, fieldOrderMap, headerArgMap, fieldArgMap } from './config'
import { CarRecordsSaerchBar, CarInfosSaerchBar, PioRecordsSaerchBar, EmployeeRecordsSaerchBar, CarStatisticsSaerchBar, CarStatisticsDash, TotalOutputSaerchBar } from './components'
import { ReportViewModel, IReportViewModel, SearchCondition } from './report.view-model'
import { ItemListDto } from '@src/store/report.slice'
import './style.scss'
import _ from 'lodash'

function Report(props: IReportViewModel) {
  const {
    currentPage,
    category,
    itemListData,
    handlePrevOnClick,
    handleNextOnClick,
    handleMoveToOnClick,
    handleDetailOnClick,
    handleEditPioBtnOnClick,
    handleEditCarInfo,
    handleDeleteCarInfo
  } = props
  const searchBarProps = pick(props, ['factoryOptions', 'carModelOptions', 'pioItemOptions', 'searchCondition', 'searchOnClick', 'downloadOnClick'])
  const { searchCondition } = props
  const componentsMap = {
    'car-records': <CarRecordsSaerchBar {...searchBarProps} />,
    'car-infos': <CarInfosSaerchBar {...searchBarProps} />,
    'pio-records': <PioRecordsSaerchBar {...searchBarProps} />,
    'employee-records': <EmployeeRecordsSaerchBar {...searchBarProps} />,
    'car-statistics': <CarStatisticsSaerchBar {...searchBarProps} />,
    'total-output': <TotalOutputSaerchBar {...searchBarProps} />
  }

  const argfieldProcess = (fieldSet: string[], argFieldSet: string[]): string[] => {
    const fieldArgIndex = _.findIndex(fieldSet, v => v === 'arg')
    const order = fieldArgIndex !== -1
      ? [...fieldSet.slice(0, fieldArgIndex), ...argFieldSet, ...fieldSet.slice(fieldArgIndex + 1)]
      : fieldSet
    return order
  }

  const getArg = (
    category: string,
    searchCondition: SearchCondition,
    itemListData: ItemListDto,
    argMap: { [reportCategory: string]: { [category: string]: string[] } }
  ): string[] => {
    if (_.isEmpty(itemListData)) return []
  
    const categoryMap = argMap[category]
    
    if (categoryMap && !_.isEmpty(searchCondition.category)) {
      return categoryMap[searchCondition.category] || []
    }
  
    if (category === 'pio-records') {
      return itemListData.argFieldNames || []
    }
  
    return []
  }
  
  const headerArg = getArg(category, searchCondition, itemListData, headerArgMap)
  const fieldArg = getArg(category, searchCondition, itemListData, fieldArgMap)

  const headerOrder = argfieldProcess(headerMap[category], headerArg)
  const fieldOrder = argfieldProcess(fieldOrderMap[category], fieldArg)


  return (
    <Main pageTitle={titleMap[category]}>
      <div className='report'>
        {componentsMap[category]}
        {
          !_.isEmpty(itemListData) 
          && category !== 'car-statistics'
          && <Table
            header={headerOrder}
            fieldOrder={fieldOrder}
            data={itemListData?.data || []}
            totalNumber={itemListData?.totalNumber || 0}
            totalPages={itemListData?.totalPages || 0}
            currentPage={currentPage}
            prevOnClick={handlePrevOnClick}
            nextOnClick={handleNextOnClick}
            moveToOnClick={handleMoveToOnClick}
            editOnClick={
              category === 'pio-records'
                ? handleEditPioBtnOnClick
                : category === 'car-infos'
                  ? handleEditCarInfo
                  : undefined
            }
            viewOnClick={category === 'car-records' ? handleDetailOnClick : undefined}
            delOnClick={category === 'car-infos' ? handleDeleteCarInfo : undefined}
          />
        }
        {
          !_.isEmpty(itemListData)
          && category === 'car-statistics'
          && <CarStatisticsDash itemListData={itemListData} />
        }
      </div>
    </Main>
  )
}

export default bind(Report, ReportViewModel)
